import { TEXTBLOCK_IMAGE_MAX_COUNT } from '../constants/limits';

export const getRemainingTextBlockImageCount = (
  currentCount: number,
): number => Math.max(0, TEXTBLOCK_IMAGE_MAX_COUNT - currentCount);

export const canAppendTextBlockImages = (
  currentCount: number,
  incomingCount: number,
): boolean => (
  incomingCount > 0 &&
  currentCount + incomingCount <= TEXTBLOCK_IMAGE_MAX_COUNT
);
